'use client';

import {
  builder,
  BuilderComponent,
  BuilderContent,
  useIsPreviewing,
} from '@builder.io/react';
import DefaultErrorPage from 'next/error';
import { type ComponentProps } from 'react';

import { BuilderExperimentTracking } from '../../atoms/builder-experiment-tracking';

type BuilderPageProps = ComponentProps<typeof BuilderComponent>;

export function RenderBuilderContent({
  content,
  apiKey,
  ...args
}: BuilderPageProps) {
  if (apiKey && !builder.apiKey) {
    builder.init(apiKey);
  }

  // Call the useIsPreviewing hook to determine if
  // the page is being previewed in Builder
  const isPreviewing = useIsPreviewing();
  // If `content` has a value or the page is being previewed in Builder,
  // render the BuilderComponent with the specified content and model props.
  if (content || isPreviewing) {
    return (
      <BuilderContent content={content} model={String(args.model)}>
        {(data, _loading, fullContent) => (
          <>
            <BuilderExperimentTracking
              experimentName={data?.experimentation?.name}
              experimentVariant={data?.experimentation?.variant}
              experimentSplit={data?.experimentation?.split}
            />
            <BuilderComponent content={fullContent} apiKey={apiKey} {...args} />
          </>
        )}
      </BuilderContent>
    );
  }
  // If the `content` is falsy and the page is
  // DefaultErrorPage with a 404.
  return <DefaultErrorPage statusCode={404} />;
}
